import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  align-items: flex-end;
`;
Body.displayName = 'Body';

export const Container = styled.div`
  border-bottom: 10px solid #8ed80c;
  display: flex;
  font-family: 'KoHo', sans-serif;
  font-size: 42px;
`;
Container.displayName = 'Container';

export const ColorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 16px;
`;
ColorsContainer.displayName = 'ColorsContainer';

export const ColorsItem = styled.div`
  flex-grow: 1;
`;
ColorsItem.displayName = 'ColorsItem';

export const Logo = styled.img`
  height: 95px;
  margin-right: 8px;
`;
Logo.displayName = 'Logo';

export const Points = styled.div`
  min-width: 45px;
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  align-items: center;
  background: rgb(143, 60, 131);
  background: linear-gradient(
    180deg,
    rgba(143, 60, 131, 1) 35%,
    rgba(105, 24, 76, 1) 100%
  );
  color: #fff;
  display: flex;
  font-weight: bold;
  justify-content: center;
  min-width: 100px;
  padding: 0 16px;
  text-align: center;
`;
PointsContainer.displayName = 'PointsContainer';

export const Space = styled.div``;
Space.displayName = 'Space';

export const TeamColor = styled.div`
  width: 16px;
`;
TeamColor.displayName = 'TeamColor';

export const TeamName = styled.div`
  background: rgb(15, 147, 175);
  background: linear-gradient(
    180deg,
    rgba(15, 147, 175, 1) 35%,
    rgba(7, 123, 136, 1) 100%
  );
  color: #fff;
  min-width: 85px;
  padding: 0 16px;
  text-align: center;
`;
TeamName.displayName = 'TeamName';

export const Timer = styled.div`
  align-items: center;
  background: rgb(15, 147, 175);
  background: linear-gradient(
    180deg,
    rgba(15, 147, 175, 1) 35%,
    rgba(7, 123, 136, 1) 100%
  );
  color: #fff;
  display: flex;
  justify-content: center;
  min-width: 145px;
  padding: 0 16px;
  text-align: center;
`;
Timer.displayName = 'Timer';

export const Wrapper = styled.section`
  display: flex;
`;
Wrapper.displayName = 'Wrapper';
